import { isEmpty, startsWith } from 'lodash-es';
import debug from 'debug';
import axios, { AxiosResponse } from 'axios';

const log = debug('itp:core:downloads');

const DOWNLOAD_TIMEOUT_MS = 60000;

export function getFileBLOB(
  href: string,
  fileName?: string,
  options?: { timeout?: number },
) {
  let f: string = fileName || getFilenameFromURL(href) || '';

  log('getFileBlob: url=%s, filename=%s', href, f);

  if (!f) {
    return;
  }
  f = normalizeFileName(f);

  return axios
    .get(href, {
      timeout: DOWNLOAD_TIMEOUT_MS,
      ...options,
      responseType: 'arraybuffer',
    })
    .then((response) => {
      const serverFileName = extractFilenameFromContentDisposition(response);

      return {
        file: new File([response.data], f, {
          type: response.headers['content-type'],
        }),
        fileName: serverFileName ? normalizeFileName(serverFileName) : f,
      };
    });
}

export function normalizeFileName(filename: string) {
  return filename.replace('\\', '-').replace('/', '-');
}

export function getFilenameFromURL(url: string) {
  if (!url) {
    return;
  }

  const parts = url.split('/');

  return parts.pop() || parts.pop(); // handle potential trailing slash
}

export function normalizeLink(url: string) {
  if (url == null || isEmpty(url)) {
    return;
  }

  if (startsWith(url, '#')) {
    return url;
  }

  const loc = location,
    u = new URL(url);

  if (u.host === loc.host && u.protocol !== loc.protocol) {
    u.protocol = loc.protocol;
    return decodeURIComponent(u.toString());
  }

  return url;
}

export function extractFilenameFromContentDisposition(response: AxiosResponse) {
  const disposition = response.headers['content-disposition'];

  let result;

  if (disposition) {
    result = extractFileName(disposition);
  }

  log(
    'extractFilenameFromContentDisposition: `%s`; result=`%s`',
    disposition,
    result,
  );

  return result;
}

function extractFileName(disposition: string): string | undefined {
  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;

  if (utf8FilenameRegex.test(disposition)) {
    return decodeURIComponent(utf8FilenameRegex.exec(disposition)![1]);
  }

  // prevent ReDos attacks by anchoring the ascii regex to string start and
  //  slicing off everything before 'filename='
  const filenameStart = disposition.toLowerCase().indexOf('filename=');
  if (filenameStart == -1) {
    return;
  }

  const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
  const partialDisposition = disposition.slice(filenameStart);

  const matches = asciiFilenameRegex.exec(partialDisposition);
  if (matches != null && matches[2]) {
    return matches[2];
  }
}
